angular.module('zc.commonApi')

.factory 'ProjectBadgePositionAdjustment', ($resource, $q, BaseProjectCrudService) ->
  class ProjectBadgePositionAdjustment extends BaseProjectCrudService

  new ProjectBadgePositionAdjustment(
    $resource
    $q
    '/api/master/projects/:projectId/badge_position_adjustments/:id'
    'badge_position_adjustment'
    'badge_position_adjustments'
  )



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/common_api/api/badge_position_adjustments.service.coffee